import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { FormInput } from './FormInput';

export const SecretInput = ({
  placeholder,
  style,
  password = '',
  onChange,
  isRequired,
  isError = false,
  errorMessage = null,
  errorMessageStyle = {},
  autoComplete = 'password'
}) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <FormInput
      style={style}
      type={showPassword ? 'text' : 'password'}
      value={password}
      placeholder={placeholder}
      autoComplete={autoComplete}
      onChange={onChange}
      isError={isError || !password}
      errorMessage={errorMessage}
      isRequired={isRequired}
      endAdornment={
        <InputAdornment position="end">
          <IconButton
            disableRipple
            aria-label="toggle password visibility"
            onClick={() => setShowPassword(!showPassword)}
            edge="end"
            sx={{ padding: '1.5rem', color: '#AAA6B9' }}
          >
            {showPassword ? (
              <VisibilityOff sx={{ fontSize: 20 }} />
            ) : (
              <Visibility sx={{ fontSize: 20 }} />
            )}
          </IconButton>
        </InputAdornment>
      }
      errorMessageStyle={errorMessageStyle}
    />
  );
};
